import React, { useEffect, useState } from 'react';

import ArrowCircleLeft from '../Images/arrowCircleLeft.svg';
import ArrowCircleRight from '../Images/arrowCircleRight.svg';
import CampaignConceptPageOne from '../Images/CampaignConceptPg1.jpg';
import CampaignConceptPageTwoOne from '../Images/CampaignConceptPg2_1.jpg';
import CampaignConceptPageTwoTwo from '../Images/CampaignConceptPg2_2.jpg';
import CampaignConceptPageTwoThree from '../Images/CampaignConceptPg2_3.jpg';
import CampaignConceptPageTwoFour from '../Images/CampaignConceptPg2_4.jpg';
import CampaignConceptPageTwoFive from '../Images/CampaignConceptPg2_5.jpg';
import CampaignTitleBackground from '../Images/CampaignServiceTitleBackground.png';
import CommercialTitleBackground from '../Images/CommericalServiceTitleBackground.png';
import CommercialConceptPageOne from '../Images/CommercialConceptPg1.png';
import CommercialConceptPageTwo from '../Images/CommercialConceptPg2.png';
import ColorPaletteBackground from '../Images/ColorPalletBackground.png';
import ResearchTopLeft from '../Images/ResearchTopLeft.svg';
import ResearchTopRight from '../Images/ResearchTopRight.svg';
import ResearchBottomLeft from '../Images/ResearchBottomLeft.svg';
import ResearchBottomRight from '../Images/ResearchBottomRight.svg';
import ExperimentalStationIcon from '../Images/ExperimentalStationIcon.png';
import PrgrssnServiceIcon from '../Images/PrgrssnServiceIcon.png';

import '../CSS/Components/ServiceDetailShowcase.css';

const conceptConfigs = {
  eventCampaigns: {
    title: 'CAMPAIGN',
    formatTitle: 'EXP. STATION',
    titleBackground: CampaignTitleBackground,
    partnerLogo: ExperimentalStationIcon,
    partnerName: 'Experimental Station',
    pageOneBackground: CampaignConceptPageOne,
    pageTwoBackgrounds: [
      CampaignConceptPageTwoOne,
      CampaignConceptPageTwoTwo,
      CampaignConceptPageTwoThree,
      CampaignConceptPageTwoFour,
      CampaignConceptPageTwoFive,
    ],
    palette: ['#fbc547', '#ae2c23', '#ffffff'],
    titleColor: '#ad2920',
    conceptColor: '#ffffff',
    formatBackground: '#fbc5479a',
    formatAccent: '#ad2920',
    styleColor: '#ae2c23',
    episodeBackground: '#fbc547',
    episodeAccent: '#ad2920',
    copy: {
      format: <>A themed series of content pieces and a live event around answering the topic of &quot;What is Greatness?&quot;.</>,
      goal: <>Expand Experimental Station&apos;s reach into the broader Chicago creative community and create an opportunity that platforms creatives in front of a larger audience</>,
      content: [
        <><strong>Live event:</strong> Discussion panel, live performances, Q&amp;A sessions</>,
        <>Artist <strong>interviews</strong></>,
        <><strong>Promotional trailers</strong></>,
        <>Event <strong>recap videos</strong></>,
      ],
      why: <>Associates Exp. Station with fostering communal spaces for next-gen talent while <strong>building brand love in music and art communities</strong></>,
      impact: <>Built a repeatable cultural-programming format that led to continued collaboration with Experimental Station and <strong>deeper engagement with Chicago&apos;s creative community</strong></>,
      tone: <>Cinematic documentary style with <strong>warm, low-key lighting</strong>, intimate close-ups, and candid performance coverage. The visual language keeps the artists feeling raw and personal</>,
    },
  },
  commercialContent: {
    title: 'COMMERCIAL',
    formatTitle: 'PRGRSSN',
    titleBackground: CommercialTitleBackground,
    partnerLogo: PrgrssnServiceIcon,
    partnerName: 'PRGRSSN',
    pageOneBackground: CommercialConceptPageOne,
    pageTwoBackgrounds: [CommercialConceptPageTwo],
    palette: ['#fbc547', '#969684', '#3e5188'],
    titleColor: '#fbc547',
    conceptColor: '#969684',
    formatBackground: '#3e5188',
    formatAccent: '#fbc547',
    styleColor: '#3e5188',
    episodeBackground: '#3e5188',
    episodeAccent: '#fbc547',
    copy: {
      format: <>A fashion-led visual campaign pairing an editorial photo series with <strong>short-form film series centered on Jackie R&apos;s legacy</strong></>,
      goal: <><strong>Translate Jackie&apos;s story of courage, connection, and belonging</strong> into a contemporary campaign that introduces PRGRSSN to a wider culture-focused audience</>,
      content: [
        <><strong>Campaign film</strong> series</>,
        <>Partner-led <strong>Film screening</strong></>,
        <>Behind-the-scenes/<strong>Production Breakdown</strong></>,
        <>Multi Platform-ready <strong>Reels</strong></>,
      ],
      why: <>Connects PRGRSSN&apos;s fashion identity to a meaningful cultural story, giving the collection <strong>an emotional foundation beyond the product</strong></>,
      impact: <>Created a cohesive campaign system that positions PRGRSSN at the intersection of <strong>fashion, history, and community</strong> across multiple digital formats</>,
      tone: <><strong>Whimsical</strong> cinematic visuals with <strong>playful color</strong>, The campaign balances heritage storytelling with <strong>dramatically expressive performances</strong></>,
    },
  },
};

const getConceptStyles = (concept) => ({
  '--service-title-color': concept.titleColor,
  '--service-concept-color': concept.conceptColor,
  '--service-format-background': concept.formatBackground,
  '--service-format-accent': concept.formatAccent,
  '--service-style-color': concept.styleColor,
  '--service-episode-background': concept.episodeBackground,
  '--service-episode-accent': concept.episodeAccent,
});

function ArrowButton({ direction, onClick, label }) {
  return (
    <button
      type="button"
      className={`service-detail__arrow service-detail__arrow--${direction}`}
      onClick={onClick}
      aria-label={label}
    >
      <img src={direction === 'left' ? ArrowCircleLeft : ArrowCircleRight} alt="" />
    </button>
  );
}

function ConceptTitle({ concept }) {
  return (
    <div className="service-detail__concept-banner">
      <img className="service-detail__title-background" src={concept.titleBackground} alt="" />
      <div className="service-detail__title-copy">
        <strong>{concept.title}</strong>
        <span>CONCEPT</span>
        <small>COLLAB WITH</small>
        <img
          className={`service-detail__partner-logo service-detail__partner-logo--${concept.partnerName === 'PRGRSSN' ? 'prgrssn' : 'experimental-station'}`}
          src={concept.partnerLogo}
          alt={concept.partnerName}
        />
      </div>
    </div>
  );
}

function ConceptPage({ variant, concept }) {
  if (variant === 2) {
    return (
      <div className="service-detail__campaign-page service-detail__campaign-page--two" style={getConceptStyles(concept)}>
        <div className="service-detail__note service-detail__note--why">
          <h3>WHY IT WORKS</h3>
          <p>{concept.copy.why}</p>
        </div>
        <div className="service-detail__note service-detail__note--impact">
          <h3>IMPACT</h3>
          <p>{concept.copy.impact}</p>
        </div>
        <div className="service-detail__note service-detail__note--tone">
          <h3><span>TONE</span> &amp; <em>STYLE</em></h3>
          <p>{concept.copy.tone}</p>
        </div>
        <div className="service-detail__palette">
          <img className="service-detail__palette-background" src={ColorPaletteBackground} alt="" />
          <strong>COLOR PALLETS</strong>
          {concept.palette.map((color) => (
            <span key={color} className="service-detail__swatch" style={{ backgroundColor: color }} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div
      className="service-detail__campaign-page"
      style={getConceptStyles(concept)}
    >
      <ConceptTitle concept={concept} />
      <div className="service-detail__note service-detail__note--format service-detail__note--campaign-format">
        <h3><span>{concept.formatTitle}</span><br />FORMAT</h3>
        <p>{concept.copy.format}</p>
      </div>
      <div className="service-detail__note service-detail__note--goal">
        <h3>GOAL</h3>
        <p>{concept.copy.goal}</p>
      </div>
      <div className="service-detail__content-cluster">
        <div className="service-detail__note service-detail__note--content">
          <h3>CONTENT</h3>
          <ul>
            {concept.copy.content.map((item, index) => <li key={index}>{item}</li>)}
          </ul>
        </div>
        {concept.partnerName === 'PRGRSSN' && (
          <div className="service-detail__episode"><strong>EACH</strong><span>EPISODE&nbsp;&nbsp;&nbsp;&nbsp;(3 EP)</span></div>
        )}
      </div>
    </div>
  );
}

function ConceptBackground({ images, isActive }) {
  if (!isActive) return null;

  return (
    <div
      className={`service-detail__background-layer ${isActive ? 'is-active' : ''}`}
      data-image-count={images.length}
      aria-hidden="true"
    >
      {images.map((image) => <img key={image} src={image} alt="" decoding="async" />)}
    </div>
  );
}

function ServiceDetailShowcase({ serviceId, initialPageIndex = 0, onExit, onConnect, onPageChange }) {
  const [pageIndex, setPageIndex] = useState(initialPageIndex);
  const concept = conceptConfigs[serviceId] || conceptConfigs.commercialContent;

  useEffect(() => {
    setPageIndex(initialPageIndex);
  }, [initialPageIndex, serviceId]);

  useEffect(() => {
    onPageChange?.(pageIndex);
  }, [onPageChange, pageIndex]);

  const goBack = () => setPageIndex((currentPage) => Math.max(0, currentPage - 1));
  const goForward = () => setPageIndex((currentPage) => Math.min(2, currentPage + 1));

  return (
    <div className="service-detail">
      <div className="service-detail__backgrounds">
        <ConceptBackground images={[concept.pageOneBackground]} isActive={pageIndex === 0} />
        <ConceptBackground images={concept.pageTwoBackgrounds} isActive={pageIndex === 1} />
      </div>
      <div className="service-detail__track" style={{ transform: `translateX(-${pageIndex * 100}%)` }}>
        <article className="service-detail__page service-detail__page--concept">
          <ConceptPage variant={1} concept={concept} />
        </article>
        <article className="service-detail__page service-detail__page--concept">
          <ConceptPage variant={2} concept={concept} />
        </article>
        <article className="service-detail__page service-detail__page--research">
          <div className="service-detail__research-grid" aria-label="Market research">
            <img className="service-detail__research-corner service-detail__research-corner--top-left" src={ResearchTopLeft} alt="Market research" />
            <img className="service-detail__research-corner service-detail__research-corner--top-right" src={ResearchTopRight} alt="" />
            <img className="service-detail__research-corner service-detail__research-corner--bottom-left" src={ResearchBottomLeft} alt="" />
            <img className="service-detail__research-corner service-detail__research-corner--bottom-right" src={ResearchBottomRight} alt="" />
          </div>
        </article>
      </div>

      {pageIndex < 2 && <button type="button" className="service-detail__exit" onClick={onExit} autoFocus>EXIT</button>}
      {pageIndex < 2 && <button type="button" className="service-detail__connect" onClick={onConnect}>CONNECT</button>}
      {pageIndex > 0 && <ArrowButton direction="left" onClick={goBack} label="Previous concept page" />}
      {pageIndex === 0 && (
        <ArrowButton
          direction="right"
          onClick={goForward}
          label="Next concept page"
        />
      )}
      {pageIndex === 1 && (
        <ArrowButton
          direction="right"
          onClick={goForward}
          label="Next research page"
        />
      )}
    </div>
  );
}

export default ServiceDetailShowcase;